module.exports = {
  "id": "coconut",
  "title": "coconut",
  "image": "provision/parts/coconut/coconut.png",
  "info": [
    {
      "text": "Add a refreshing coconut to your project",
      "image": "provision/parts/coconut/coconut.png"
    }
  ],
  "exposedVariables": [],
  "codeImage": "provision/parts/coconut/coconut.png"
} ;